import { TSlugStatus } from 'app/types/TSlugStatus';

export const SLUG_RULE_MESSAGE = 'Only a-z, 0-9 and - are allowed';

export const getSlugStatusMessage = (status: TSlugStatus) => {
  switch (status) {
    case 'checking':
      return 'Checking availability…';
    case 'available':
      return 'Available';
    case 'taken':
      return 'Already in use';
    case 'error':
      return 'Could not check availability.';
    default:
      return SLUG_RULE_MESSAGE;
  }
};
